module.exports = __webpack_public_path__ + "img/tap.25f50db9.png";